
import Vue from "vue";
import { Maintenance, MaintenanceItem } from "@/@core/maintenance";

export default Vue.extend({
  data() {
    return {
      cuurentMaintenance: undefined as MaintenanceItem | undefined,
      maintenanceMessage: null as string | null,
    };
  },
  async mounted() {
    this.cuurentMaintenance = await Maintenance.getCurrent();
    this.setMaintenanceMessage();
  },
  methods: {
    setMaintenanceMessage() {
      if (this.cuurentMaintenance) {
        this.maintenanceMessage = this.cuurentMaintenance.message[this.$i18n.locale === "fr" ? "fr" : "nl"];
      }
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.setMaintenanceMessage();
      },
    },
  },
});
